import React from "react";
import {
  prizeTrophy,
  silverMedal,
  thirdMedal,
  ParticipationIcon,
} from "./icons";

function Rewards({ data }) {

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-xl font-gilroy-semibold">Rewards</h1>

      {data?.length > 0 && data?.map((reward, index) => (
        <div className=" py-2 px-3 bg-[#f6f5fa] rounded-lg flex justify-between items-center" key={reward}>
          <div className="flex gap-4 items-center">
            <div className=" bg-white p-1 rounded-lg">
              <img src={index === 0 ? prizeTrophy : index === 1 ? silverMedal : index === 2 ? thirdMedal : ParticipationIcon} alt="vector" className=" size-6 " />
            </div>
            <h2 className="text-[#707C97] font-gilroy-medium">{index === 0 ? "Winner" : `${getOrdinal(index + 1)} Winner`}</h2>
          </div>
          <p className="text-[#008080] font-gilroy-semibold">{reward}/-</p>
        </div>
      ))}


    </div>
  );
}

export default Rewards;
